import React from "react";
import { useNavigate } from "react-router-dom";

const CategoriesGrid = ({
  title,
  categories = [],
  limit,
  showViewAll,
}) => {
  const navigate = useNavigate();

  if (!Array.isArray(categories) || categories.length === 0) return null;

  // 👉 Open single category page
  const handleClick = (categoryId) => {
    navigate(`/categories/${categoryId}`);
  };

  // 👉 Open All Categories page (API will be called there)
  const handleViewAll = () => {
    navigate("/categories");
  };

  const displayedCategories = limit
    ? categories.slice(0, limit)
    : categories;

  return (
    <div className="px-0 py-4">

      {/* Title + View All */}
      {title && (
        <div className="flex justify-between items-left mb-4">
          <h2 className="text-2xl font-bold">{title}</h2>


          {showViewAll && categories.length > limit && (
            <div
              onClick={handleViewAll}
              className="px-4 py-1.5 bg-stone-300 rounded-lg
                         inline-flex justify-center items-center gap-1.5
                         cursor-pointer hover:bg-stone-400 transition"
            >
              <div className="text-black text-sm font-medium uppercase tracking-wide">
                View All
              </div>
            </div>
          )}
        </div>
      )}

      {/* Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {displayedCategories.map((category, index) => {
          if (!category) return null;

          return (
            <div
              key={category.categoryId || index}
              className="cursor-pointer flex flex-col items-center"
              onClick={() => handleClick(category.categoryId)}
            >
              <div className="relative w-full h-[300px] overflow-hidden shadow rounded-lg hover:shadow-md transition">
                <img
                  src={
                    category.imageUrl ||
                    "https://kokaki-images.s3.amazonaws.com/uploads%2Fimage+%285%29.png"
                  }
                  alt={category.categoryName}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="mt-2 text-sm font-medium text-left w-full">
                {category.categoryName}
                <div className="text-xs text-gray-500 mt-1">
                  {category.events?.length || 0} events
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoriesGrid;